/**
 * Role hierarchy для per-field ACL. Phase 4.
 *
 *   READER (0) < ANALYST (1) < ADMIN (2)
 *
 * canViewField(current, field.min_view_role) → admin контролю видимості
 * полів через Settings → Структура даних → field → View role / Edit role.
 */

export type Role = 'READER' | 'ANALYST' | 'ADMIN';

const RANK: Record<Role, number> = { READER: 0, ANALYST: 1, ADMIN: 2 };

export function roleAtLeast(current: Role | null | undefined, required: Role | null | undefined): boolean {
  if (!required) return true; // no restriction
  if (!current) return false;
  return RANK[current] >= RANK[required];
}

/** Чи admin може БАЧИТИ поле (з обмеженням min_view_role). */
export function canViewField(currentRole: Role | null | undefined, minViewRole: string | null | undefined): boolean {
  return roleAtLeast(currentRole, minViewRole as Role | null | undefined);
}

/** Чи admin може РЕДАГУВАТИ поле (з обмеженням min_edit_role).
 *  Якщо min_edit_role не заданий — fallback на min_view_role (бачить → можна редагувати,
 *  далі це гейтиться на бек-енді PATCH-роутом який вимагає ADMIN+). */
export function canEditField(
  currentRole: Role | null | undefined,
  minEditRole: string | null | undefined,
  minViewRole: string | null | undefined,
): boolean {
  return roleAtLeast(currentRole, (minEditRole ?? minViewRole) as Role | null | undefined);
}
